import TrackingDetails from "./TrackingDetails";

export default TrackingDetails;
